import { useIsInEntryShell } from "@entry/EntryShellContext";
import { useProjectedChart } from "@hooks";
import { BarChart } from "./BarChart";
import { useStyles } from "./styles";
import { ProjectedChartProps } from "./types";

export const ProjectedChart = ({ header, footer, style }: ProjectedChartProps) => {
  const { width, height } = useProjectedChart();

  // Inside the entry shell the card stretches to the form column so it
  // lines up with the adjuster and CTA; the fixed-width chart centers.
  const inEntryShell = useIsInEntryShell();

  const styles = useStyles();

  return (
    <div style={{ ...styles.wrapper }}>
      <div
        style={{
          ...styles.container,
          width: inEntryShell ? "100%" : width,
          boxSizing: inEntryShell ? "border-box" : undefined,
          height: inEntryShell ? "auto" : height,
          gap: inEntryShell ? 12 : undefined,
          ...style,
        }}
      >
        {header}

        <div style={inEntryShell ? { alignSelf: "center" } : undefined}>
          <BarChart />
        </div>

        {footer}
      </div>
    </div>
  );
};
